module.exports = __webpack_public_path__ + "d5db73711ab20a1cbddc6161b8a4acf1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/wing-1.png
// module id = 3469
// module chunks = 0